<template>

    <div id="map">

        <div class="map-wrapper"> 
                
            <iframe width="425" height="350" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://www.openstreetmap.org/export/embed.html?bbox=4.890160560607911%2C52.37673227180061%2C4.89917278289795%2C52.380989305865334&amp;layer=mapnik&amp;marker=52.37886084013341%2C4.89466667175293"></iframe>
        
        </div>
    
    </div>
  
</template>

<script>
export default {
    data: () => {
        return {
            visibility: 'visible',
            toggled: false
        }
    },
    methods: {
        toggleText() {
            this.toggled = true;
            this.visibility = 'visible';
        }
    }
}
</script>

<style scoped lang="scss">

@import 'main.scss';

#map {
    width: 100%;
    filter: grayscale(100%);

    display: flex;
    justify-content: center;
    align-items: flex-start;

        @media only screen and (max-width: 700px) {
           align-items: center;
    }
}

.map-wrapper {
    padding: 2rem;

    overflow: hidden;
    width: 100%;


    @media only screen and (max-width: 700px) {
        padding: 0rem;
        max-height: 30rem;
        text-align: center;
    }
}

</style>